import type { ThresholdSport } from '@painpal/contracts';
import { Activity, Bike, Footprints } from 'lucide-react';
import { ToggleTabs } from '../../components/ToggleTabs';
import styles from './sportSettings.module.css';

const OPTIONS = [
  { value: 'ride', label: 'RIDE', icon: Bike },
  { value: 'run', label: 'RUN', icon: Footprints },
  { value: 'other', label: 'OTHER SPORTS', icon: Activity },
] as const satisfies readonly { value: ThresholdSport; label: string; icon: typeof Bike }[];

export function SportSwitcher({ sport, onChange }: { sport: ThresholdSport; onChange: (sport: ThresholdSport) => void }) {
  return (
    <div className={styles.switcherRow}>
      <ToggleTabs label="Sport" options={OPTIONS} value={sport} onChange={onChange} className={styles.switcher} />
      <span className={`sr-only-phone ${styles.switcherHint}`}>EACH SPORT KEEPS ITS OWN THRESHOLDS · MAX HR IS SHARED</span>
    </div>
  );
}
